/* eslint-disable */
"use strict";
/* eslint-disable no-restricted-imports */
import React, { useContext, useState, useEffect } from "react";
import { Row, Col, Button,DropdownButton,ButtonGroup,Dropdown } from "react-bootstrap";
import Moment from 'react-moment';
import { Link, useParams,useHistory } from "react-router-dom";
import cf from '../../services/codeformatter';
import { injectIntl } from "react-intl";
import { FlitServiceContext } from "../../services/flitService";
import { useSubheader } from '../../../_metronic/layout/_core/MetronicSubheader';
import { Card, CardHeader, CardBody, CardHeaderTitle } from "../../../_metronic/_partials/controls";
import { useSelector } from "react-redux";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import { AvailableScheduleDialog } from "../Consol/AvailableScheduleDialog";

function OneStopQuote(props) {
  //LayoutSubheader({ title: "QuoteLists" });
  const bgImage = toAbsoluteUrl("/media/svg/patterns/taieri.svg");
  const bgImage2 = toAbsoluteUrl("/media/svg/patterns/rhone-2.svg");
  const bgImage3 = toAbsoluteUrl("/media/svg/patterns/aare.svg");
  const { intl} = props;
  const history = useHistory();
  const { user } = useSelector(state => state.auth);

  const wordWrap = { wordWrap: "break-word" };
  const subheader = useSubheader();
  const [showAvailableScheduleDialog, setShowAvailableScheduleDialog] = useState(false);
  function closeAvailableScheduleDialog(isUpdated){
    setShowAvailableScheduleDialog(false);
  }
  useEffect(() => {
  }, []);

  return (<>

    {

      <Row>
        <Col>
          <Card style={{height:"700px"}}>
            <CardHeader title={intl.formatMessage({ id: "ONESTOP_TITLE" })}></CardHeader>
            <CardBody>

            <Row>
            <Col>
              <Row>
                <Col md='6' className="pr-12">
                <Card style={{backgroundImage: `url(${bgImage2})`, backgroundPosition:"right bottom", backgroundRepeat:'no-repeat', backgroundColor:"#3699ff", margin:"50px",width:"90%" }}>
            <CardBody>
            <h3 class="text-white font-weight-bolder">{intl.formatMessage({ id: "ONESTOP_CONSOL_TITLE" })}</h3>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_CONSOL_LINE1" })}</p>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_CONSOL_LINE2" })}</p>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_CONSOL_LINE3" })}</p>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_CONSOL_LINE4" })}</p>
            <Button variant="secondary" size="sm" onClick={() => setShowAvailableScheduleDialog(true)}>
                    {intl.formatMessage({ id: "ONESTOP_CONSOL_BUTTON" })}
            </Button>
            </CardBody></Card>

            <Row>
              <Col style={{paddingLeft:"60px"}}>
                <h4>{intl.formatMessage({ id: "ONESTOP_CONSOL_PREP_TITLE" })}</h4><br/>
                {intl.formatMessage({ id: "ONESTOP_CONSOL_PREP1" })} - <a href='https://www.pnpline.co.kr/2022/11/01/%EC%95%84%EB%A7%88%EC%A1%B4-%EB%9D%BC%EB%B2%A8/' target='_blank'>{intl.formatMessage({ id: "LINK" })}</a><br/>
                {intl.formatMessage({ id: "ONESTOP_CONSOL_PREP2" })} - <a href='https://www.pnpline.co.kr/2022/11/01/ior-bond-%EA%B5%AC%EB%A7%A4/' target='_blank'>{intl.formatMessage({ id: "LINK" })}</a>
              </Col>
            </Row>
                </Col>
                <Col md='6' className="pr-12">
                <Card style={{backgroundImage: `url(${bgImage})`, backgroundPosition:"right bottom", backgroundRepeat:'no-repeat', backgroundColor:"#3F4254" , margin:"50px",width:"90%"  }}>
            <CardBody>
            <h3 class="text-white font-weight-bolder">{intl.formatMessage({ id: "MENU.SHIPMENT" })}</h3>
            <p class="text-muted font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_OCEAN_LINE1" })}</p>
            <p class="text-muted font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_OCEAN_LINE2" })}</p>
            <Button variant="primary" size="sm" onClick={e=> history.push("/quote/request")}>
                    {intl.formatMessage({ id: "ONESTOP_OCEAN_BUTTON" })}
            </Button>
            </CardBody></Card>
            <Card style={{backgroundImage: `url(${bgImage3})`, backgroundPosition:"right bottom", backgroundRepeat:'no-repeat', backgroundColor:"#f1711c" , margin:"50px",width:"90%"  }}>
            <CardBody>
            <h3 class="text-white font-weight-bolder">{intl.formatMessage({ id: "MENU.AIR_EXPRESS" })}</h3>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_AIR_LINE1" })}</p>
            <p class="text-white opacity-75 font-size-lg mt-5 mb-10">{intl.formatMessage({ id: "ONESTOP_AIR_LINE2" })}</p>
            <Button variant="secondary" size="sm" onClick={e=> history.push("/airexpress/request")}>
                    {intl.formatMessage({ id: "REQUEST_AIR_EXPRESS" })}
            </Button>
            </CardBody></Card>
                </Col>
              </Row>



            </Col>
            </Row>



            </CardBody>
          </Card>
        </Col>
        <AvailableScheduleDialog show={showAvailableScheduleDialog} onHide={closeAvailableScheduleDialog}/>
      </Row>}

  </>
  );
}

export default injectIntl(OneStopQuote);
